import React, { Component } from 'react';

// How long a single dot stays lit. Slow enough to read as breathing rather
// than blinking, quick enough that three of them feel like one gesture.
const PHASE_MS = 380;

// The blue this chat already gives the other person: their name in
// ChatBoxMessageListItem, the "New messages" rule, the unread pill. A line
// about them is theirs too, so it borrows that colour instead of adding one.
const THEM = '#408ec9';

// A message that has not been said yet, holding the place it will land in.
//
// Everything here is styled inline and animated from state on purpose. This
// renders inside a popped-out chat window, so nothing may depend on a
// stylesheet making the trip - which rules out @keyframes. An inline
// transition is a style property rather than a stylesheet rule, so it
// survives; the phase it transitions between comes from setState.
export class ChatBoxTypingIndicator extends Component {
    constructor(props) {
        super(props);
        this.state = {
            phase: 0,
            // Read once. The interval is never started when this is set, so
            // reduced motion costs nothing rather than being animated and hidden.
            reducedMotion: !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches),
        };
    }

    componentDidMount() {
        if (this.state.reducedMotion) {
            return;
        }
        // Only mounted while someone is actually typing, so the interval's
        // lifetime is bounded by the typing itself.
        this.phaseInterval = setInterval(this.advancePhase, PHASE_MS);
    };

    componentWillUnmount() {
        if (this.phaseInterval) {
            clearInterval(this.phaseInterval);
            this.phaseInterval = null;
        }
    };

    advancePhase = () => {
        this.setState((previous) => ({ phase: (previous.phase + 1) % 3 }));
    };

    renderDot = (index) => {
        const lit = !this.state.reducedMotion && this.state.phase === index;
        return (
            <span
                key={index}
                style={{
                    display: 'inline-block',
                    width: '5px',
                    height: '5px',
                    marginLeft: index === 0 ? '0px' : '4px',
                    borderRadius: '50%',
                    backgroundColor: THEM,
                    verticalAlign: 'middle',
                    opacity: this.state.reducedMotion ? 0.55 : (lit ? 1 : 0.3),
                    transform: lit ? 'translateY(-2px)' : 'translateY(0)',
                    transition: 'opacity 220ms ease-out, transform 220ms ease-out',
                }}
            />
        );
    };

    render() {
        return (
            // The message line's own shape - their name, bold, in their colour,
            // then the colon - with the timestamp column left off, because there
            // isn't one yet. That missing column, and the reduced opacity, are
            // what mark the line as not yet said.
            <div style={{ cursor: 'default', opacity: 0.72, paddingTop: '2px', overflowWrap: 'break-word' }}>
                <b>
                    <span style={{ color: THEM }}>{this.props.name + ": "}</span>
                </b>
                <span aria-hidden="true" style={{ whiteSpace: 'nowrap' }}>
                    {[0, 1, 2].map(this.renderDot)}
                </span>
                {/* Three dots say nothing out loud, so the announcement is a sentence. */}
                <span
                    style={{
                        position: 'absolute',
                        width: '1px',
                        height: '1px',
                        overflow: 'hidden',
                        clip: 'rect(0 0 0 0)',
                        whiteSpace: 'nowrap',
                    }}
                >
                    {this.props.name} is typing
                </span>
            </div>
        );
    };
}

export default ChatBoxTypingIndicator;



// WEBPACK FOOTER //
// ./src/components/ChatBoxTypingIndicator.js